import { URLS } from '../../../const/nav'
import { authFetch } from '../../../services/authFetch'

const URL = {
  technical: '/estudios/?scope=own',
  ophthalmologist: '/estudios/informados',
  patient: '/estudios/propios'
}

export const searchAllEvaluations = async (token, rol) => {
  if (rol === 'admin' || rol === 'admin_institucion') {
    return []
  }
  try {
    const r = await authFetch(URLS.BACKEND_URL + URL[rol], {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`
      }
    })
    if (r.ok) {
      return await r.json()
    } else {
      console.error('Error en la solicitud:', r.status, r.statusText)
      return null
    }
  } catch (error) {
    console.error('Error durante la solicitud:', error)
    return null
  }
}

export const fetchEstudiosTecnicoPorAlcance = async (token, scope) => {
  try {
    const r = await authFetch(`${URLS.BACKEND_URL}/estudios/?scope=${scope}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`
      }
    })
    if (r.ok) {
      return await r.json()
    } else {
      console.error('Error al obtener estudios por alcance:', r.status, r.statusText)
      return null
    }
  } catch (error) {
    console.error('Error durante la solicitud de estudios por alcance:', error)
    return null
  }
}
